import React from 'react';
import { default as MuiAccordion } from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import accordionStyles from './AccordionStyles';

type AccordionProps = {
  className: string;
  slots: Array<{ title: string; content: string }>;
}

const StyledAccordion = styled('div')(({ theme }) => accordionStyles);

const Accordion: React.FC<AccordionProps> = (props) => {
  const [expanded, setExpanded] = React.useState<string | false>('panel0');

  const { className, slots } = props;

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <StyledAccordion className={'inline ' + className}>
      {slots.map((slot, index) => (
        <MuiAccordion defaultExpanded={index === 0} expanded={expanded === 'panel' + index} onChange={handleChange('panel' + index)} key={index}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <h3>{slot.title}</h3>
          </AccordionSummary>
          <AccordionDetails>
            {slot.content}
          </AccordionDetails>
        </MuiAccordion>
      ))}
    </StyledAccordion>
  );
}

export default Accordion;